import { NORMALIZED_COLOR_KEYS } from "../constants";
import { normalizeKeys } from "./helpers";
export const fontSizeToTailwindClass = (fontSize) => {
    const normalizedKey = normalizeKeys(fontSize);
    switch (normalizedKey) {
        case "small":
            return "text-sm md:text-base";
        case "large":
            return "text-lg md:text-xl";
        default:
            return "text-base md:text-is2_md";
    }
};
const NORMALIZED_COLOR_MAP = {
    [NORMALIZED_COLOR_KEYS.PRIMARY_BLUE]: "is2-blue",
    [NORMALIZED_COLOR_KEYS.DARK_BLUE]: "is2-blue-500",
    [NORMALIZED_COLOR_KEYS.LIGHT_BLUE]: "is2-blue-50",
    [NORMALIZED_COLOR_KEYS.LIGHT_GREEN]: "is2-green-50",
    [NORMALIZED_COLOR_KEYS.LIGHT_YELLOW]: "is2-yellow-100",
    [NORMALIZED_COLOR_KEYS.WHITE]: "white",
};
export const colorToBackgroundClass = (color) => {
    const normalizedKey = normalizeKeys(color);
    return NORMALIZED_COLOR_MAP[normalizedKey] ? `!bg-${NORMALIZED_COLOR_MAP[normalizedKey]}` : "";
};
